export type OrganizationRole =
  | "owner"
  | "admin"
  | "organization_admin"
  | "super_admin"
  | "member"
  | "viewer";

export const canManageOrganization = (
  role?: OrganizationRole | null,
): boolean => role === "owner" || role === "admin";

export const canManageOrganizationMembers = (
  role?: OrganizationRole | null,
): boolean => canManageOrganization(role);

export const canChangeOrganizationMemberRoles = (
  role?: OrganizationRole | null,
): boolean => role === "owner";

export const canManageStyleIntelligence = (
  role?: OrganizationRole | null,
): boolean => (
  role === "owner"
  || role === "admin"
  || role === "organization_admin"
  || role === "super_admin"
);
